'use client'

import { SupportedLocale } from '@/lib/i18n/locales'
import { createContext, useContext } from 'react'

type LocaleContextType = {
  currentLocale: SupportedLocale
  localeOptions: readonly SupportedLocale[]
}

const LocaleContext = createContext<LocaleContextType | null>(null)

type LocaleProviderProps = {
  children: React.ReactNode
  currentLocale: SupportedLocale
  localeOptions: readonly SupportedLocale[]
}

export const LocaleProvider = ({ children, currentLocale, localeOptions }: LocaleProviderProps) => {
  return (
    <LocaleContext.Provider value={{ currentLocale, localeOptions }}>
      {children}
    </LocaleContext.Provider>
  )
}

export const useLocale = () => {
  const context = useContext(LocaleContext)
  if (!context) {
    throw new Error('useLocale must be used within a LocaleProvider')
  }
  return context
}
